import { render, staticRenderFns } from "./quyujiaohu.vue?vue&type=template&id=f324efd4"
import script from "./quyujiaohu.vue?vue&type=script&lang=js"
export * from "./quyujiaohu.vue?vue&type=script&lang=js"
import style0 from "./quyujiaohu.vue?vue&type=style&index=0&id=f324efd4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports